import { ConvertDtokToMagicLinkResponse } from '@sxm-de/dev-kits/microservices-sdk/types';

export async function convertDtokToMagicLink({
    baseUrl,
    token,
}: {
    baseUrl: string;
    token: string;
}): Promise<ConvertDtokToMagicLinkResponse> {
    const url = `${baseUrl}/account/sal/dtok2magiclink`;
    const headers = {
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
    };
    const response = await fetch(`${url}`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            token,
        }),
    });
    const parsedJson = await response.json();
    if (!response.ok) return Promise.reject(await parsedJson.error);
    return parsedJson.data;
}
